import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
//   TopToolbar,
//   CreateButton,
//   EditButton,
} from 'react-admin';

import { DateField } from './DateField';
// import { BooleanField } from './BooleanField';
// import { ChipField } from './ChipField';

// const BannerListActions = () => {
//   return (
//     <TopToolbar>
//         <CreateButton
//           basePath="/banners"
//           variant="contained"
//           label="New Banner"
//         />
//     </TopToolbar>
//   );
// };

const ReportsList = (props) => {
    return (
    <List
    {...props}
    //   actions={<BannerListActions />}
    //   bulkActionButtons={false}
    >
    <Datagrid>
        <TextField source="id" label="ID" />
        {/* <ChipField source="type" label="Tipo" size="small" />
        <BooleanField
            source="active"
            label="status"
            falsyValueLabel="Não ativo"
            truthyValueLabel="Ativo"
        /> */}
        <ReferenceField label="Usuário que reportou" source="reporter_user" reference="users" link="show">
            <TextField source="full_name" />
        </ReferenceField>
        <ReferenceField label="Usuário reportado" source="reported_user" reference="users" link="show">
            <TextField source="full_name" />
        </ReferenceField>
        <TextField source="created_at" label="Data do report" />
        {/* <EditButton /> */}
    </Datagrid>
    </List>
);
}

export default ReportsList;